let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iE9PC")).then(() => parcelRequire('e3A3t'));